<template>
  <form>
    <ValidationObserver ref="obsFieldsSearch" v-if="this.$store.state.configAuth.ADAzure === 'false'">
      <FormSearchClient :FieldsForm="formSearch" :ModelForm="formAZDModel" :method="executeProcess" />
    </ValidationObserver>
    Login Okta V 1.0
    <div class="d-flex justify--center mt-3">
      <img src="./../../../assets/icons/loading-cargando.gif" class="gift">
    </div>
    <div class="d-flex justify--center mt-3">
      <button id="loadForm" type="submit" @click="loginUser" class="loginbtn primaryBtn primaryBtn">Administrativo</button>
    </div>
  </form>
</template>
<script>
import FormSearchClient from '@/components/forms/Forms.vue'
import authentication from '@/store/authentication'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'login',
  data () {
    return {
      redirectDas: true,
      formAZDModel: {
        given_name: 'PRUEBAS IBERO',
        unique_name: '',
      },
      formSearch: [
        {
          id: 'unique_name',
          model: 'unique_name',
          name: 'Correo Electrónico Ibero',
          type: 'input',
          placeholder: 'Correo Electrónico Ibero',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-12',
        },
      ],
    }
  },
  components: {
    FormSearchClient,
  },
  methods: {
    sendForm () {
      if (this.$store.state.configAuth.ADAzure === 'false') {
        let loader = this.$loading.show()
        return new Promise((resolve, reject) => {
          this.$refs.obsFieldsSearch.validate().then(results => {
            if (!results) {
              resolve(false)
            } else {
              if (this.formAZDModel.unique_name.indexOf('ibero.edu.co') >= 1 || this.formAZDModel.unique_name.indexOf('laiberocol') >= 1) {
                this.$session.start()
                this.$session.set('IberoJWTAdmin', '')
                this.$session.set('IberoJWTAdmin', this.formAZDModel)
                this.getUserDB()
                resolve(true)
              } else {
                this.formAZDModel.unique_name = ''
                resolve(false)
              }
            }
            loader.hide()
          })
        })
      } else {
        this.$router.push({ name: 'dashboard' })
      }
    },
    executeProcess: function (event, refer) {
      return true
    },
    getUserDB (datos) {
      var prueba = IberoHelpers.getToken(this.$store)
      prueba.then(Response2 => {
      //  alert('hola mundo :: ' + Response2 + ' .. ' + process.env.VUE_APP_TOKEN)
        var loginType = IberoHelpers.getUserLoginAuth(this.$store, this.$session.get('IberoJWTAdmin').unique_name, Response2)
        loginType.then(Response => {
          if (Response) {
            if (Response.data.length >= 1) {
              this.$session.set('IberoJWTAdminLogin', '')
              this.$session.set('IberoJWTAdminLogin', Response.data[0])
              if (this.$route.params.externalLink !== undefined) {
                if (this.$route.params.externalLink === 'CASEID2') {
                  this.$router.push({ path: '/admin/CreateCase/2' })
                }
              } else {
                this.$router.push({ name: 'dashboard' })
              }
            } else {
              this.$session.remove('IberoJWTAdminLogin')
              this.$router.push({ name: 'not-found-simple' })
            }
          } else {
            this.$session.remove('IberoJWTAdminLogin')
            this.$router.push({ name: 'not-found-simple' })
          }
        })
      })
    },
    loginUser () {
      let loader = this.$loading.show()
      authentication.initialize(this.$store.state.configAuth).then(_ => { }).catch(e => this.$router.push({ name: 'dashboard' }))
      this.$session.start()
      this.$session.set('IberoJWTAdmin', '')
      this.$session.set('IberoJWTAdmin', authentication.getUserProfile())
      if (!this.$session.get('IberoJWTAdminLogin')) {
        if (!(this.$session.get('IberoJWTAdmin').unique_name.indexOf('ibero.edu.co') >= 1) && !(this.$session.get('IberoJWTAdmin').unique_name.indexOf('laiberocol') >= 1)) {
          this.$router.push({ name: 'not-found-simple' })
        } else if (authentication.getUserProfile()) {
          // Busca usario despues de pasar la autenticación
          this.getUserDB()
        }
        loader.hide()
      } else {
        if (!(this.$session.get('IberoJWTAdmin').unique_name.indexOf('ibero.edu.co') >= 1) && !(this.$session.get('IberoJWTAdmin').unique_name.indexOf('laiberocol') >= 1)) {
          this.$session.remove('IberoJWTAdminLogin')
          this.$router.push({ name: 'not-found-simple' })
        } else {
          IberoHelpers.sendDataLog(this.$store, authentication.getUserProfile())
          if (this.$route.params.externalLink !== undefined) {
            if (this.$route.params.externalLink === 'CASEID2') {
              this.$router.push({ path: '/admin/CreateCase/2' })
            }
          } else {
            this.$router.push({ name: 'dashboard' })
          }
        }
        loader.hide()
      }
    },
  },
  created: function () {
    if (this.$store.state.configAuth.ADAzure === 'true') {
      this.loginUser()
    } else {
      if (this.$session.get('IberoJWTAdminLogin')) {
        if (this.$route.params.externalLink !== undefined) {
          if (this.$route.params.externalLink === 'CASEID2') {
            this.$router.push({ path: '/admin/CreateCase/2' })
          }
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      }
    }
  },
}
</script>

<style lang="scss">
.loginbtn primaryBtn {
  background-color: #fff !important;
  border-color: #222 !important;
  cursor: pointer;
  border-radius: 5px;
  width: 80%;
  padding: 2%;
  color: #222 !important;
  margin-top: 30px;
}

.espere
{
  color: #222;
  border: none;
  text-align: center;
}
</style>
